"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _d = _interopRequireDefault(require("../../lib/d3"));

var _chart = _interopRequireDefault(require("./chart"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DiscreteBarChartHorizontal = /*#__PURE__*/function (_Chart) {
  _inherits(DiscreteBarChartHorizontal, _Chart);

  var _super = _createSuper(DiscreteBarChartHorizontal);

  function DiscreteBarChartHorizontal() {
    _classCallCheck(this, DiscreteBarChartHorizontal);

    return _super.apply(this, arguments);
  }

  _createClass(DiscreteBarChartHorizontal, [{
    key: "defaultParams",
    get: function get() {
      var _objectSpread2;

      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(DiscreteBarChartHorizontal.prototype), "defaultParams", this)), {}, (_objectSpread2 = {
        resizable: true,
        barPadding: 0.18,
        showXAxis: true
      }, _defineProperty(_objectSpread2, "showXAxis", true), _defineProperty(_objectSpread2, "showValues", false), _defineProperty(_objectSpread2, "animationDuration", 200), _defineProperty(_objectSpread2, "tickFormats", {
        x: function x(d) {
          return d;
        },
        y: function y(d) {
          return d;
        }
      }), _defineProperty(_objectSpread2, "x", {
        tickSeparation: 120,
        minTickThreshold: 60
      }), _objectSpread2));
    }
  }, {
    key: "initDOM",
    value: function initDOM() {
      var _this$params = this.params,
          margins = _this$params.margins,
          chartClass = _this$params.chartClass,
          resizable = _this$params.resizable,
          showValues = _this$params.showValues,
          showXAxis = _this$params.showXAxis,
          showYAxis = _this$params.showYAxis;
      var _this$dimensions = this.dimensions,
          width = _this$dimensions.width,
          height = _this$dimensions.height;
      this.svg = _d.default.select(this.container).append('svg').attr('class', ['bar-chart', chartClass].join(' ')).attr('transform-origin', '0 0 0');
      this.g = this.svg.append('g');

      if (showXAxis) {
        this.xAxisGroup = this.g.append('g').attr('class', 'axis x');
      }

      if (showYAxis) {
        this.yAxisGroup = this.g.append('g').attr('class', 'axis y');
      } // bar group


      this.allBars = this.g.append('g').attr('class', 'all-bars'); // base line

      if (showValues) {
        this.baseLine = this.g.append('line').attr('class', 'baseline');
      }

      if (!resizable) {
        this.fitToSize();
      }
    }
  }, {
    key: "fitToSize",
    value: function fitToSize() {
      var margins = this.params.margins;
      var _this$dimensions2 = this.dimensions,
          width = _this$dimensions2.width,
          height = _this$dimensions2.height;
      this.svg.attr('width', width + margins.left + margins.right).attr('height', height + margins.top + margins.bottom);
      this.g.attr('transform', "translate(".concat(margins.left, ", ").concat(margins.top, ")"));
      this.applyRanges();

      if (this.xAxisGroup) {
        this.xAxisGroup.attr('transform', "translate(0,".concat(height, ")")).call(this.buildXAxis());
      }

      if (this.yAxisGroup) {
        this.yAxisGroup.call(this.buildYAxis());
      }
    }
  }, {
    key: "initScales",
    value: function initScales() {
      var barPadding = this.params.barPadding;
      var _this$dimensions3 = this.dimensions,
          width = _this$dimensions3.width,
          height = _this$dimensions3.height;
      this.y = _d.default.scaleBand().padding(barPadding);
      this.x = _d.default.scaleLinear().rangeRound([0, width]);
      this.applyRanges();
    }
  }, {
    key: "applyRanges",
    value: function applyRanges() {
      var _this$dimensions4 = this.dimensions,
          width = _this$dimensions4.width,
          height = _this$dimensions4.height;

      if (this.x) {
        this.x.rangeRound([0, width]);
      }

      if (this.y) {
        this.y.rangeRound([height, 0]);
      }
    }
  }, {
    key: "preTransformData",
    value: function preTransformData(data) {
      return data;
    }
  }, {
    key: "update",
    value: function update(data) {
      if (data && data.length) {
        this.data = this.preTransformData(data);
      }

      if (this.data && this.data.length) {
        this.draw();
      }
    }
  }, {
    key: "getXPosition",
    value: function getXPosition(d) {
      return this.x(Math.min(this.valueAccessor(d), 0));
    }
  }, {
    key: "valueAccessor",
    value: function valueAccessor(d) {
      return d;
    }
  }, {
    key: "keyAccessor",
    value: function keyAccessor(d) {
      return d;
    }
  }, {
    key: "formatValueLabel",
    value: function formatValueLabel(s) {
      return s;
    }
  }, {
    key: "buildXAxis",
    value: function buildXAxis() {
      var height = this.dimensions.height;
      var x = this.params.x;
      return _d.default.axisBottom(this.x).tickValues(_utils.generateTickValuesInclusive.call(this, {
        scale: this.x,
        tickSeparation: x.tickSeparation,
        minTickThreshold: x.minTickThreshold
      })).tickFormat(this.params.tickFormats.x).tickPadding(10).tickSizeOuter(0).tickSizeInner(-height);
    }
  }, {
    key: "buildYAxis",
    value: function buildYAxis() {
      var width = this.dimensions.width;

      var axis = _d.default.axisLeft(this.y).tickSize(0).tickSizeInner(-width);

      if (typeof this.params.tickFormats.y === 'function') {
        axis.tickFormat(this.params.tickFormats.y);
      }

      return axis;
    }
  }, {
    key: "draw",
    value: function draw() {
      var _this = this;

      try {
        var _this$params2 = this.params,
            resizable = _this$params2.resizable,
            margins = _this$params2.margins,
            showValues = _this$params2.showValues,
            animationDuration = _this$params2.animationDuration;
        var _this$dimensions5 = this.dimensions,
            width = _this$dimensions5.width,
            height = _this$dimensions5.height;
        this.x.domain(_d.default.extent(this.data.map(this.valueAccessor).concat([0])));
        this.y.domain(this.data.map(this.keyAccessor));

        if (resizable) {
          this.fitToSize();
        }

        var zero = this.x(0);

        if (this.baseLine) {
          this.baseLine.attr('x1', zero).attr('x2', zero).transition().duration(200).attr('y1', 0).attr('y2', height);
        }

        this.bars = this.allBars.selectAll('g.bar').data(this.data);
        this.barsEnter = this.bars.enter().append('g').attr('class', 'bar');
        this.barsExit = this.bars.exit().remove();
        this.barsEnterUpdate = this.bars.merge(this.barsEnter);
        this.barsEnter.append('rect').attr('y', 0) // every bar starts out at 0, then gets updated
        .attr('x', this.x(0)).attr('fill', function (d) {
          return _this.getColor(d);
        });
        this.barsEnterUpdate.attr('transform', function (d) {
          return "translate(0,".concat(_this.y(_this.keyAccessor(d)), ")");
        }).select('rect').attr('height', this.y.bandwidth()).transition().duration(animationDuration).attr('x', function (d) {
          return _this.getXPosition(d);
        }).attr('width', function (d) {
          var val = _this.valueAccessor(d);

          return Math.max(1, Math.abs(_this.x(val) - _this.x(0)));
        });

        if (showValues) {
          this.barsEnter.append('text').attr('dy', '0.35em').attr('class', 'value');
          this.barsEnterUpdate.select('text.value').text(function (d) {
            return _this.formatValueLabel(_this.valueAccessor(d));
          }).attr('y', this.y.bandwidth() / 2).attr('text-anchor', function (d) {
            var value = _this.valueAccessor(d);

            return value >= 0 ? 'left' : 'right';
          }).transition().duration(animationDuration).attr('x', function (d) {
            return Math.abs(_this.x(_this.valueAccessor(d)) - _this.x(0));
          }).attr('dx', function (d) {
            var value = _this.valueAccessor(d);

            return value >= 0 ? '0.35em' : '-0.35em';
          });
        }
      } catch (err) {
        console.error(err);
      }
    }
  }]);

  return DiscreteBarChartHorizontal;
}(_chart.default);

exports.default = DiscreteBarChartHorizontal;